import { render, staticRenderFns } from "./ScoreBulk.vue?vue&type=template&id=8c203844&"
import script from "./ScoreBulk.vue?vue&type=script&lang=js&"
export * from "./ScoreBulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports